import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "hooks";
import { PayloadState } from "interfaces";
import { getUser, refresh } from "store/thunks";
import { ROUTES } from "constants/routes";
import { USER_TYPE } from "constants/userType";

export function AdminOnlyRoute() {
  const { refreshRequestState, getUserRequestState, user } = useAppSelector(
    (state) => state.auth
  );
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(refresh());
  }, []);

  useEffect(() => {
    if (refreshRequestState === PayloadState.fulfilled) {
      dispatch(getUser());
    }
  }, [refreshRequestState]);

  useEffect(() => {
    if (refreshRequestState === PayloadState.rejected) {
      navigate(ROUTES.login);
      return;
    }

    if (
      getUserRequestState === PayloadState.fulfilled &&
      user?.type !== USER_TYPE.ADMIN
    ) {
      navigate(ROUTES.login);
    }
  }, [refreshRequestState, getUserRequestState, user]);
}
